module.exports = {
          srcSet: __webpack_public_path__ + "c7ee2ae1ec7519712ae3728ae48366fd-1094.png"+" 1094w",
          images:[ {path: __webpack_public_path__ + "c7ee2ae1ec7519712ae3728ae48366fd-1094.png",width: 1094,height: 504}],
          src: __webpack_public_path__ + "c7ee2ae1ec7519712ae3728ae48366fd-1094.png",
          toString:function(){return __webpack_public_path__ + "c7ee2ae1ec7519712ae3728ae48366fd-1094.png"},
          
          width: 1094,
          height: 504
        }